/**
 * Whether the page is running inside the Bits native app's webview.
 *
 * Both shells inject a bridge object before the document loads — Android an
 * `@JavascriptInterface` binding, iOS a `WKScriptMessageHandler` — so this is
 * readable synchronously on the very first render, before anything paints.
 * `useNativeAppNavigation` posts messages through the same two objects.
 */
export function isNativeWebView(): boolean {
  return Boolean(window.BitsAndroidJSInterface || window.webkit?.messageHandlers?.callbackHandlerFile);
}

/**
 * How long to hold the first paint waiting for the native shell to hand over a
 * session, before giving up and rendering the app signed out.
 *
 * The shell calls `setBitsAccessToken` (see `public/index.html`) once its own
 * bootstrap finishes, which lands after this bundle has already mounted. Long
 * enough to cover that gap; short enough that a webview which never sends a
 * token — the user really is signed out — is not left staring at nothing.
 */
export const NATIVE_TOKEN_GRACE_MS = 2500;
